import styled from 'styled-components';
import {
  MIN_TABLET_BREAKPOINT,
  SELECTORS,
  TABLET_BREAKPOINT,
  UBISOFT_BLUE
} from '../../constants/constants';

interface IKeepRewardStyle {
  isMobileTitle: boolean;
}

export const KeepBlockContainer = styled.section`
  ${SELECTORS} & {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 100px;
    border: 1px solid #A2A2A2;
    box-sizing: border-box;
    border-radius: 8px;
  }
  //Animation scss
  //Title animation
  .title-animation {
      transition: all 0.4s ease;
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
      transform-origin: center;
      backface-visibility: hidden;
      &.scaleUp {
        -webkit-animation: scale-up 1s ease forwards;
        animation: scale-up 1s ease forwards;
      }
    }
  //Description animation
  .description-animation {
      &.scaleUp {
        -webkit-animation: fade 1s ease forwards;
        animation: fade 1s ease forwards;
      }
    }
`;



export const ImageSectionContainer = styled.div`
   ${SELECTORS} & {
      margin: 30px 0 30px auto;
      width: 30%;
   }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
   ${SELECTORS} & {
       width: 100%;
       margin: 30px auto 30px auto;
   }
  } 
`;

export const ImageContainer = styled.div`
    ${SELECTORS} & {
      width: 100%;
      margin: auto;
      height: 100%;
    }
    img{
      margin: auto!important;
    }
`;

export const KeepRewardTextContainer = styled.div`
  ${SELECTORS} & {
      margin: auto;
      display: block;
      align-content: flex-end;
      width: 70%;
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
         width: 100%;
         text-align: center;
       }
    }
`;

export const KeepRewardTitle = styled.h2`
  display : ${({ isMobileTitle } : IKeepRewardStyle) => isMobileTitle ? 'none' : 'block'} !important;
  ${SELECTORS} & {
    margin: 0 auto 22px 0;
    font-size: 50px;
    line-height: 60px;
    span{
        color: ${UBISOFT_BLUE};
        font-size: 50px;
        line-height: 60px;
        font-weight: bold;
    }
  }
  
  @media (max-width: ${TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
        font-size: 32px;
        line-height: 38px;
        text-align: left;
        
        span{
          font-size: 32px;
          line-height: 38px;
       }
      }
  }
  
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    display : ${({ isMobileTitle } : IKeepRewardStyle) => isMobileTitle ? 'block' : 'none'} !important;
    ${SELECTORS} & {
        font-size: 32px;
        line-height: 38px;
        width: 90%;
        margin: 20px auto 0 auto;
        text-align: center;
        
        span{
          font-size: 32px;
          line-height: 38px;
       }
     }
  } 
`;


export const KeepRewardDescription = styled.p`
  ${SELECTORS} & {
    font-size: 22px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
   @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    ${SELECTORS} & {
       width: 90%;
       margin: auto auto 20px auto;
     }
  } 
`;

